import React from "react";

import { Button } from "@/Components/v2/atoms/Button";
import { Stack } from "@/Components/v2/atoms/Stack";

type ActionButtonsProps = {
  isSubmitting: boolean;
  onCancel: () => void;
};

export const ActionButtons: React.FC<ActionButtonsProps> = ({ isSubmitting, onCancel }) => {
  return (
    <Stack direction="column" spacing={1} alignItems="center" pt={1}>
      <Button
        type="submit"
        variant="contained"
        disabled={isSubmitting}
        sx={{
          borderRadius: 50,
          textTransform: "none",
        }}
      >
        {isSubmitting ? "Creating..." : "Create Action Plan"}
      </Button>
      <Button
        variant="text"
        onClick={onCancel}
        disabled={isSubmitting}
        sx={{ borderRadius: 50, textTransform: "none" }}
      >
        Cancel
      </Button>
    </Stack>
  );
};
